import { useCallback } from "react";
import { EModule } from "../../../../../../enums";
import useAuth from "../../../../../../hooks/useAuth";
import { ICity } from "../../../../../../interfaces";
import CitiesService from "../../../../../../services/http/services/CitiesService";
import { EmitError } from "../../../../../../utils/EmitError";
import { EmitSuccessAlert } from "../../../../../../utils/EmitSuccessAlert";
import {
    colInputsConfigDescription,
    colInputsConfigDescriptionExpanded,
} from "../../GridStyle";

export default function useConfigStep(
    needsToInformPointsConfigEffectiveDate: boolean,
    needsToInformTicketsConfigEffectiveDate: boolean,
    city?: ICity
) {
    const colInputsPointsConfigDescription = needsToInformPointsConfigEffectiveDate ? colInputsConfigDescription : colInputsConfigDescriptionExpanded;
    const colInputsTicketsConfigDescription = needsToInformTicketsConfigEffectiveDate ? colInputsConfigDescription : colInputsConfigDescriptionExpanded;
    const { activeCity, setUserActiveCity, updateUserCityOnStorage } = useAuth();

    const handleRemoveModuleOnCity = useCallback((module: EModule) => {

        async function handleRemove(module: EModule) {
            try {
                const updatedCity = await CitiesService.removeCityModule({cityId: Number(city?.id), module});

                // se usuário editou cidade que está logado, atualiza os dados
                if (Number(city?.id) === activeCity?.id && updatedCity!) {
                    setUserActiveCity(updatedCity);
                }

                // // Se usuário estiver vinculado a cidade editada, atualiza os dados dela no local storage
                updateUserCityOnStorage(updatedCity!);

                EmitSuccessAlert('Município atualizado com sucesso!');

            } catch (err) {
                EmitError(err, true, 'editCity_iashdausda');
            }
        }

        handleRemove(module)


    }, [city, activeCity, setUserActiveCity, updateUserCityOnStorage]);


    return {
        colInputsPointsConfigDescription,
        colInputsTicketsConfigDescription,
        handleRemoveModuleOnCity
    }
}
